module.exports = __webpack_public_path__ + "img/thechroma2collection.594a0b4d.png";